import React from 'react';
import { graphql, ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';
import gql from 'graphql-tag';

import CoreLayout from './layouts/PageLayout/PageLayout';
import Landing from './routes/Landing';
import CreateCompany from './routes/Create';
import AuthenticateUser from './routes/Login';
import JobsRoute from './routes/Jobs';
import SignupRoute from './routes/Signup';

import { logoutUser } from '../../store/auth';
import Spinner from '../../components/Spinner';

const CompanyQuery = gql`
query {
  Companies: userCompany {
    id
    name
  }
}
`;

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

// MLaden Enpoints
// const publicEndpoint = 'https://wz8nhmslqe.execute-api.us-east-2.amazonaws.com/dev4mladen/graphql/public';
// const protectedEndpoint = 'https://wz8nhmslqe.execute-api.us-east-2.amazonaws.com/dev4mladen/graphql/protected';

// Cian Endpoints
const publicEndpoint = 'https://ckgy6ldryc.execute-api.us-east-1.amazonaws.com/dev/graphql/public';
const protectedEndpoint = 'https://ckgy6ldryc.execute-api.us-east-1.amazonaws.com/dev/graphql/protected';

export const createRoutes = (store) => {
  return ({
    path        : 'company',
    component   : connect(mapStateToProps)(props => {
      let GraphQLURI = __GraphQLPublic || publicEndpoint; // eslint-disable-line no-undef
      if (props.authedUserID !== null) {
        GraphQLURI = __GraphQLProtected || protectedEndpoint; // eslint-disable-line no-undef
      }

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          }
        }
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    }),
    indexRoute  : Landing(store),
    childRoutes : [
      CreateCompany(store),
      AuthenticateUser(store),
      SignupRoute(store),
      JobsRoute(store),
      { // For redirecting based on User's companys
        path: 'home',
        component: graphql(
            CompanyQuery, {
              name: 'CompanyData',
            }
          )(class Home extends React.Component {
            componentWillReceiveProps (nextProps) { // handle redirect
              console.log(nextProps);
              if (nextProps.CompanyData.loading === false) {
                console.log(nextProps.CompanyData.Companies);
                if (nextProps.CompanyData.Companies.length > 0) {
                  window.location = (document.location.origin + '/company/jobs');
                } else {
                  window.location = (document.location.origin + '/company/create');
                }
              }
            }

            render () {
              return (
                <Spinner />
              );
            }
          })
      },
      { // For redirecting based on User's companys
        path: 'logout',
        component: connect(
          mapStateToProps, {
            logoutUser,
          }
        )(class Logout extends React.Component {
          componentDidMount () {
            console.log(this.props);
            if (this.props.authenticatedID !== null) {
              this.props.logoutUser();
              window.location = (document.location.origin + '/company/');
            } else {
              window.location = (document.location.origin + '/company/home');
            }
          }

          render () {
            console.log(this.props);
            return (
              <Spinner />
            );
          }
        })
      }
    ]
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/company/index.js